export const configConstants = {
  GET_CONFIGS_REQUEST: "GET_CONFIGS_REQUEST",
  GET_CONFIGS_SUCCESS: "GET_CONFIGS_SUCCESS",
  GET_CONFIGS_FAILURE: "GET_CONFIGS_FAILURE",
  GET_CONFIGS_RESET: "GET_CONFIGS_RESET",

  VIEW_CONFIG_REQUEST: "VIEW_CONFIG_REQUEST",
  VIEW_CONFIG_SUCCESS: "VIEW_CONFIG_SUCCESS",
  VIEW_CONFIG_FAILURE: "VIEW_CONFIG_FAILURE",
  VIEW_CONFIG_RESET: "VIEW_CONFIG_RESET",

  ADD_CONFIG_REQUEST: "ADD_CONFIG_REQUEST",
  ADD_CONFIG_SUCCESS: "ADD_CONFIG_SUCCESS",
  ADD_CONFIG_FAILURE: "ADD_CONFIG_FAILURE",
  ADD_CONFIG_RESET: "ADD_CONFIG_RESET",

  EDIT_CONFIG_REQUEST: "EDIT_CONFIG_REQUEST",
  EDIT_CONFIG_SUCCESS: "EDIT_CONFIG_SUCCESS",
  EDIT_CONFIG_FAILURE: "EDIT_CONFIG_FAILURE",
};
